import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { PopupService } from 'src/app/services/popup.service';
import { MESSAGES } from 'src/app/shared/constants/common.constants';

@Injectable()
export class LootboxInterceptor implements HttpInterceptor {

  constructor(private popUpService: PopupService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse)=>{
      // When error.status is 0, this means that internet is disconnected
      if(!error.status){
        this.popUpService.messsageAlert('error', error?.error?.message ?? MESSAGES.INTERNET_DISCONNECTED);
      }
      return throwError(() => error);
    }));
  }
}
